import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "12",
  "data-name": "Oko EYE"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#626997",
      d: "M2.648 9.148A15.6 15.6 0 0 1 .211 6.317L0 5.989l.205-.332a15.4 15.4 0 0 1 2.4-2.815A9.52 9.52 0 0 1 8.975 0c3.039 0 5.984 1.891 8.756 5.621l.27.363-.27.364C15.008 10.1 12.086 12 9.049 12a9.64 9.64 0 0 1-6.401-2.852M1.35 5.984A15.6 15.6 0 0 0 3.395 8.27a8.74 8.74 0 0 0 5.654 2.55c2.586 0 5.117-1.625 7.535-4.831-2.463-3.194-5.018-4.81-7.609-4.81-3.889 0-6.809 3.672-7.625 4.805m4.06-.026a3.77 3.77 0 0 1 3.649-3.886 3.773 3.773 0 0 1 3.646 3.886 3.773 3.773 0 0 1-3.646 3.886A3.77 3.77 0 0 1 5.41 5.958m1.105 0a2.633 2.633 0 0 0 2.544 2.706 2.63 2.63 0 0 0 2.535-2.706 2.63 2.63 0 0 0-2.535-2.706 2.633 2.633 0 0 0-2.543 2.706Z",
      "data-name": "Union 314"
    }, null, -1)
  ]))]))
}
export default { render: render }